import { useContext, useEffect } from "react";
import { AppContext } from "context";

//evita que o titulo da pagina selecionada fique errado no contexto 
const PageWrapper = ({ title, children }) => {
  const { selecionaPagina } = useContext(AppContext);

  useEffect(() => {
    selecionaPagina(title);
    // eslint-disable-next-line
  }, [title]);

  return children;
};

export default PageWrapper;
